import { Badge } from '@/components/shadcn/badge'
import { Button } from '@/components/shadcn/button'
import { StepperTitle } from '@/components/shadcn/stepper'
import { IconCheckMarkOutline } from '@icons/IconCheckMarkOutline'
import type { ReactElement } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { MermaidRenderer } from '../../MdTextComponent/MermaidRenderer'
import { useStepperStepContext } from './StepperStepContext'

export function StepperStepBody() {
  const { index, step, stepsLabel, markdownContent, canMarkAsComplete, isActive, changeStepsHandlerId } =
    useStepperStepContext()
  const { mutate: submitForm } = useSubmitForm(changeStepsHandlerId || '', [])

  return (
    <>
      <div className="w-full space-y-1.5">
        {stepsLabel && (
          <div className="text-2xs font-semibold uppercase text-muted-foreground">
            {stepsLabel} {index + 1}
          </div>
        )}
        <div className="flex w-full items-center justify-between gap-x-5">
          <Badge variant="warning" className="hidden h-4 text-2xs font-bold group-data-[state=active]/step:flex">
            In Progress
          </Badge>
          <Badge variant="success" className="hidden h-4 text-2xs font-bold group-data-[state=completed]/step:flex">
            Completed
          </Badge>
          <Badge
            variant="outline"
            className="hidden h-4 text-2xs font-bold text-muted-foreground group-data-[state=inactive]/step:flex"
          >
            Pending
          </Badge>
          {canMarkAsComplete && isActive && (
            <Button
              variant="outline"
              size="sm"
              className="h-5"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                submitForm({ action: 'increment' })
              }}
            >
              <IconCheckMarkOutline className="mr-1 size-3" />
              <span className="text-2xs">Mark completed</span>
            </Button>
          )}
        </div>
      </div>
      {step.title && (
        <StepperTitle className="text-start text-base font-semibold group-data-[state=inactive]/step:text-muted-foreground">
          {step.title}
        </StepperTitle>
      )}
      {markdownContent && (
        <div className="prose prose-sm prose-neutral max-w-full dark:prose-invert group-data-[state=inactive]/step:text-muted-foreground group-data-[state=inactive]/step:[&_h1]:text-muted-foreground group-data-[state=inactive]/step:[&_h2]:text-muted-foreground group-data-[state=inactive]/step:[&_h3]:text-muted-foreground group-data-[state=inactive]/step:[&_h4]:text-muted-foreground group-data-[state=inactive]/step:[&_h5]:text-muted-foreground group-data-[state=inactive]/step:[&_h6]:text-muted-foreground group-data-[state=inactive]/step:[&_li]:text-muted-foreground group-data-[state=inactive]/step:[&_p]:text-muted-foreground">
          <Markdown
            remarkPlugins={[remarkGfm]}
            components={{
              pre({ children, ...props }) {
                const codeElement = children as ReactElement
                if (codeElement?.props?.className?.includes('language-mermaid')) {
                  return <MermaidRenderer chart={String(codeElement.props.children).replace(/\n$/, '')} />
                }
                return <pre {...props}>{children}</pre>
              },
              code({ className, children, ...props }) {
                return (
                  <code className={className} {...props}>
                    {children}
                  </code>
                )
              },
            }}
          >
            {markdownContent}
          </Markdown>
        </div>
      )}
    </>
  )
}
